export const REGISTRATION_PATH = "/api/users/phone-sign-up";
export const SET_PINCODE_PATH = "api/users/:id/pin-code";
export const PROFILE_URL = "/api/profiles";
export const ADDRESS_URL = "api/addresses";
export const PROFILE_BY_PHONE_PATH = "/api/profiles/phone-number";
